module.exports = __webpack_public_path__ + "img/stages.d9a5055f.png";